import React, { useState, useEffect } from 'react';

import { LOGOUT } from 'ConstComponents';

import { Grid } from '@material-ui/core';

import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from '@material-ui/core';
import { SelectVirtualAccount as SELECT_VIRTUAL_ACCOUNT } from 'Components/Api/VirtualAccountAPI';
import GPAY_LOGO from 'Assets/Images/GpayPhonepe.jpg';
import BHIM_LOGO from 'Assets/Images/bhim-upi.png';
import PAYTM_LOGO from 'Assets/Images/Paytm_Logo.png';
import AMAZONPAY_LOGO from 'Assets/Images/Amazon-Pay.png';

import Logo from 'Components/Logo/Logo';

export const StaticQRView = ({
    isOpen,
    title,
    imageQRCode,
    positiveButtonTitle,
    positiveButtonClick,
    negativeButtonTitle,
    negativeButtonClick
}) => {
    const classes = commonStyle();

    const [open, setOpen] = useState(isOpen);
    const FirmName = localStorage.getItem('FirmName');

    const [VirtualAccountlist, setVirtualAccountlist] = useState([]);
    const handleNegativeButtonClick = () => {
        setOpen(false);
        negativeButtonClick();
    };
    const handlePositiveButtonClick = () => {
        window.print();
        //setOpen(false);
    };
    const GPayLogoImage = () => {
        return (
            <img
                src={GPAY_LOGO}
                height={50}
                width={90}
                style={{ padding: '10px' }}
                alt="BBPS"
            />
        );
    };
    const PaytmLogoImage = () => {
        return (
            <img
                src={PAYTM_LOGO}
                height={50}
                width={90}
                style={{ padding: '10px' }}
                alt="BBPS"
            />
        );
    };
    const BhimLogoImage = () => {
        return (
            <img
                src={BHIM_LOGO}
                height={50}
                width={90}
                style={{ padding: '10px' }}
                alt="BBPS"
            />
        );
    };

    const AmazonPayLogoImage = () => {
        return (
            <img
                src={AMAZONPAY_LOGO}
                height={70}
                width={90}
                style={{ padding: '10px' }}
                alt="BBPS"
            />
        );
    };

    const IsValidVirtualAccount = () => {
        if (VirtualAccountlist === undefined || VirtualAccountlist === null)
            return false;

        if (
            VirtualAccountlist.IFSC === undefined ||
            VirtualAccountlist.IFSC === null ||
            VirtualAccountlist.IFSC.length <= 0
        )
            return false;

        if (
            VirtualAccountlist.BankName === undefined ||
            VirtualAccountlist.BankName === null ||
            VirtualAccountlist.BankName.length <= 0
        )
            return false;

        if (
            VirtualAccountlist.AccountNumber === undefined ||
            VirtualAccountlist.AccountNumber === null ||
            VirtualAccountlist.AccountNumber.length <= 0
        )
            return false;

        return true;
    };
    const selectVirtualAccount = async () => {
        const response = await SELECT_VIRTUAL_ACCOUNT();

        //    if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            return;
        }

        let data = JSON.parse(response.data);

        if (data !== null || data !== undefined) setVirtualAccountlist(data);
    };

    useEffect(() => {
        selectVirtualAccount();
    }, []);
    return (
        <Dialog
            fullWidth
            maxWidth="sm"
            open={open}
            onClose={() => {
                setOpen(false);
                negativeButtonClick(false);
            }}
        >
            <DialogTitle id="alert-dialog-title" className={classes.title}>
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="DialogPrint">
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Grid container className="mb-5">
                            <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
                                <div className={classes.imageHeader}>
                                    <Logo />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
                                <h2 className={classes.imageHeader}>
                                    {FirmName}
                                </h2>
                            </Grid>
                        </Grid>
                        <div className={classes.imageContainer}>
                            <img
                                name="StaticQRImage"
                                src={imageQRCode}
                                height={400}
                                width={400}
                                alt={imageQRCode}
                            />
                        </div>

                        <h3 className={classes.imageHeader}>
                            Scan & Pay with any BHIM, UPI app
                        </h3>
                        <h3 className={classes.imageContainer}>
                            <GPayLogoImage />
                            <PaytmLogoImage />
                            <BhimLogoImage />
                            <AmazonPayLogoImage />
                        </h3>

                        {IsValidVirtualAccount() === false ? (
                            <>
                                <h5 className={classes.imageFooter}>
                                    <p>
                                        Your virtual account detail for instant
                                        wallet payment
                                    </p>
                                </h5>
                                <div className={classes.imageFooter}>
                                    <p>
                                        Account No. :
                                        {VirtualAccountlist.AccountNumber}
                                    </p>
                                    <p>IFSC : {VirtualAccountlist.IFSC}</p>
                                    <p>Bank : {VirtualAccountlist.BankName}</p>
                                </div>
                            </>
                        ) : null}
                    </Grid>
                </DialogContentText>
            </DialogContent>
            <DialogActions displayPrint="none">
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Button
                            onClick={handleNegativeButtonClick}
                            className={classes.CustomSecondaryButtonStylePopup}
                        >
                            {negativeButtonTitle
                                ? negativeButtonTitle
                                : 'Cancel'}
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Button
                            onClick={handlePositiveButtonClick}
                            className={classes.CustomPrimaryButtonStylePopup}
                        >
                            {positiveButtonTitle
                                ? positiveButtonTitle
                                : 'Download'}
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    );
};
